export enum UserTypeEnum {
        SuperUser = 1,
        Administrator,
        Member

}
